/************  GESTION DE LA NAVIGATION *****************/

    $('document').ready(setupNav);

    function setupNav() {
        // Fonction pour gérer la navigation
        initBurgerMenu();
        initMenu();
        $('#showSiteNav').click(showHideGroupSite);
        $('.navsitesgroup .btn-back').click(showHideGroupSite);
        $('.navigation-links > .btn-search').click(showHideSearchbar);
        $('.navigation-links a').click(function() {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'clic_cta_header',
                clic_text: $(this).find('span:last-child').text(),
            });
        });
        $('.navigation .menu a').click(trackAction);
        $(window).scroll(showHideStickyMenu);
    }
    
    // Gestion du burger menu en responsive
    function initBurgerMenu() {
        $('.burger').click(function () {
            if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $('.navigation').removeClass('overlay');
                    $('.navigation-menu').removeClass('open');
                    $('html, body').removeAttr('style');
                }else {
                    $(this).addClass('active');
                    $('.navigation').addClass('overlay');
                    $('.navigation-menu').addClass('open');
                    $('html, body').css('overflow', 'hidden');
                }
            });
        }

    // Affichage des sous menu (mega menus) en responsive
    function initMenu() {
        $('.has-childrens .btn-drop').click(function() {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parent().children('.sub-menu').slideUp(400);
            }else {
                $('.menu .btn-drop').removeClass('active');
                $(this).addClass('active');
                $('.sub-menu').slideUp(400);
                $(this).parent().children('.sub-menu').slideDown(400);
            }
        });

        // Affichage des sous-sous menu en responsive
        $('.submenu-has-children .btn-arrow-long').click(function() {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parent().parent().children('.sub-child-menu').slideUp(400);
            }else {
                $(this).addClass('active');
                $(this).parent().parent().children('.sub-child-menu').slideDown(400);
            }
        });

        // Affichage des filiales pour le footer
        $('.footer-brands .title').click(function() {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parent().children('.brands').slideUp(400);
            }else {
                $(this).addClass('active');
                $(this).parent().children('.brands').slideDown(400);
            }
        })
    }

    // Afficher / cacher le pannel les sites du groupe
    function showHideGroupSite() {
        if($('.navsitesgroup').hasClass('open')) {
            $('.fadebg').removeClass('show');
            $('.translatecontent').removeClass('slide');
            $('.navsitesgroup').removeClass('open');
            $('html, body').removeAttr('style');
        }else {
            $('.fadebg').addClass('show');
            $('.translatecontent').addClass('slide');
            $('.navsitesgroup').addClass('open');
            $('html, body').css('overflow', 'hidden');
        }
    }

    // Navigation Sticky
    function showHideStickyMenu() {
        if($(this).scrollTop() >= 150) {
            $('.navigation').addClass('fixed');
        }else {
            if($(window).width() > 1000 || ($('.joboffers-offer.show').length === 0 && $(window).width() < 1000)) $('.navigation').removeClass('fixed');
        }

        if($(this).scrollTop() >= 1000){
            $('.btn-topage').addClass('show');
        }else {
            $('.btn-topage').removeClass('show');
        }
    }

    // Afficher/cacher la barre de recherche
    function showHideSearchbar() {
        if($(this).hasClass('show')) {
            $(this).removeClass('show');
            $('.search-bar').slideUp(300);
        }else {
            $(this).addClass('show');
            $('.search-bar').slideDown(300);
        }
    }
    
    // Fonction pour tracker les actions de l'utilisateur
    function trackAction(e) {
        let menuTxt = $(this).find('span').html();
        let menuParent = undefined;
        let menuSubgroup1 = undefined;
        let menuSubgroup2 = undefined;
        // Niveau 3
        if($(this).parent().parent().hasClass('sub-child-menu')) {
            menuSubgroup2 = menuTxt;
            menuSubgroup1 = $(this).parent().parent().parent().find('.has-submenu .btnLink').html();
            menuParent = $(this).parent().parent().parent().parent().parent().parent().parent().parent().find('> a span').text();
            if(menuParent === undefined || menuParent === '' || menuParent === ' ') menuParent = $(this).parent().parent().parent().parent().parent().parent().parent().parent().find('.top-item').text();
        }else if($(this).parent().parent().hasClass('sub-menu-classic')) {
            // Niveau 2 sans enfants
            menuParent = $(this).parent().parent().parent().parent().parent().parent().find('> a span').text();
            if(menuParent === undefined || menuParent === '' || menuParent === ' ') menuParent = $(this).parent().parent().parent().parent().parent().parent().find('.top-item').text();
        }else if($(this).parent().parent().parent().hasClass('sub-menu-classic')) {
            // Niveau 2 avec enfants
            menuParent = $(this).parent().parent().parent().parent().parent().parent().parent().find('> a span').text();
            if(menuParent === undefined || menuParent === '' || menuParent === ' ') menuParent = $(this).parent().parent().parent().parent().parent().parent().parent().find('.top-item').text();
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'clic_header',
            clic_text: menuTxt,
            menu_group: menuParent,
            menu_subgroup1: menuSubgroup1,
            menu_subgroup2: menuSubgroup2
        });
        
        if(menuSubgroup1 === 'Nos entités') {
            window.dataLayer.push({
                event: 'clic_site_entite',
                site_entite: $(this).find('span').html()
            });
        }
    }